import {TenantLogoIconMap} from 'constants/tenantIconsMap';

import {useTenantId} from 'hooks/useTenantId';

export const TenantLogo = ({className}: {className?: string}) => {
  const tenantId = useTenantId();
  const tenantLogo = tenantId && TenantLogoIconMap[tenantId];

  if (!tenantLogo) {
    return null;
  }

  return (
    <img
      data-tenant-id={tenantId}
      className={className}
      src={tenantLogo.logo}
      alt='Tenant Logo'
    />
  );
};
